import { type ButtonHTMLAttributes, forwardRef } from 'react';
import { haptic } from '../lib/telegram';
import { cn } from '../lib/utils';

type Variant = 'gold' | 'primary' | 'ghost' | 'danger';

const STYLES: Record<Variant, string> = {
  gold:
    'bg-trophy-gold text-bg-night hover:bg-trophy-gold-2 shadow-gold-glow font-chunky uppercase tracking-wide',
  primary:
    'bg-bg-elevated text-text-base border border-border-strong hover:bg-bg-card font-semibold',
  ghost: 'bg-transparent text-text-dim hover:text-text-base font-semibold',
  danger: 'bg-crimson text-white font-semibold',
};

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  fullWidth?: boolean;
}

export const Button = forwardRef<HTMLButtonElement, Props>(
  ({ variant = 'primary', fullWidth, className, onClick, children, ...rest }, ref) => (
    <button
      ref={ref}
      onClick={(e) => {
        haptic.tap();
        onClick?.(e);
      }}
      className={cn(
        'inline-flex items-center justify-center gap-2 rounded-lg px-5 py-3 text-base',
        'transition-colors duration-150 active:scale-[0.98] disabled:opacity-50 disabled:cursor-not-allowed',
        'min-h-[44px]',
        fullWidth && 'w-full',
        STYLES[variant],
        className,
      )}
      {...rest}
    >
      {children}
    </button>
  ),
);
Button.displayName = 'Button';
